// import DatePicker from "components/form/DatePicker";
import DateTimePicker from 'components/form/DateTimePicker';
import TextInput from 'components/form/TextInput';
import React from 'react';

// Hall Ticket, Zoom link and Confirmation
const SevenStepOfFollowUps = ({ props, isEdit, suggestionData }) => {
  // const { handleChange, values } = props;
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } =
    props;
  const {
    conference_short_name,
    client_name,
    venue_name,
    full_address,
    map_link,
    zoom_link,
    download_zoom,
    registration_date_time,
    hall_ticket_link,
    support_email,
    support_phone,
  } = values;

  return (
    <>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Conference Short Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="conference_short_name"
            onChange={handleChange}
            value={conference_short_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.conference_short_name && errors.conference_short_name}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Client Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="client_name"
            onChange={handleChange}
            value={client_name}
            disabled={!isEdit}
            onBlur={handleBlur}
            error={touched.client_name && errors.client_name}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Venue Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="venue_name"
            onChange={handleChange}
            value={venue_name}
            disabled={!isEdit}
            suggestions={suggestionData?.venue_name}
            onBlur={handleBlur}
            error={touched.venue_name && errors.venue_name}
          />
        </div>
      </div>

      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Full Address
        </div>
        <div className="col-lg-6">
          <TextInput
            id="full_address"
            onChange={handleChange}
            value={full_address}
            disabled={!isEdit}
            suggestions={suggestionData?.full_address}
            onBlur={handleBlur}
            error={touched.full_address && errors.full_address}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Google Maps Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="map_link"
            onChange={handleChange}
            value={map_link}
            disabled={!isEdit}
            suggestions={suggestionData?.map_link}
            onBlur={handleBlur}
            error={touched.map_link && errors.map_link}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Access Zoom Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="zoom_link"
            onChange={handleChange}
            value={zoom_link}
            disabled={!isEdit}
            suggestions={suggestionData?.zoom_link}
            onBlur={handleBlur}
            error={touched.zoom_link && errors.zoom_link}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Download Zoom Background
        </div>
        <div className="col-lg-6">
          <TextInput
            id="download_zoom"
            onChange={handleChange}
            value={download_zoom}
            disabled={!isEdit}
            suggestions={suggestionData?.download_zoom}
            onBlur={handleBlur}
            error={touched.download_zoom && errors.download_zoom}
          />
        </div>
      </div>
      {/* <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Registration Venue Name
        </div>
        <div className="col-lg-6">
          <TextInput
            id="registration_venue_name"
            onChange={handleChange}
            value={registration_venue_name}
            disabled={!isEdit}
            suggestions={suggestionData?.registration_venue_name}
          />
        </div>
      </div> */}

      {/* <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Registration Street Address
        </div>
        <div className="col-lg-6">
          <TextInput
            id="registration_street_address"
            onChange={handleChange}
            value={registration_street_address}
            disabled={!isEdit}
            suggestions={suggestionData?.registration_street_address}
          />
        </div>
      </div> */}
      {/* <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Google Maps Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="venue_map_link"
            onChange={handleChange}
            value={venue_map_link}
            disabled={!isEdit}
          />
        </div>
      </div> */}
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Registration Date and Time
        </div>
        <div className="col-lg-6">
          <DateTimePicker
            id="registration_date_time"
            onChange={handleChange}
            value={registration_date_time}
            disabled={!isEdit}
            error={errors.registration_date_time}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Hall Ticket/Zoom Link
        </div>
        <div className="col-lg-6">
          <TextInput
            id="hall_ticket_link"
            onChange={handleChange}
            value={hall_ticket_link}
            disabled={!isEdit}
            suggestions={suggestionData?.hall_ticket_link}
            onBlur={handleBlur}
            error={touched.hall_ticket_link && errors.hall_ticket_link}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Support Email
        </div>
        <div className="col-lg-6">
          <TextInput
            id="support_email"
            onChange={handleChange}
            value={support_email}
            disabled={!isEdit}
            suggestions={suggestionData?.support_email}
            onBlur={handleBlur}
            error={touched.support_email && errors.support_email}
          />
        </div>
      </div>
      <div className="d-flex align-items-center flex-wrap cmb-19">
        <div className="color-black-olive text-14-400-17 col-lg-6">
          Support Phone Number
        </div>
        <div className="col-lg-6">
          <TextInput
            id="support_phone"
            onChange={handleChange}
            value={support_phone}
            disabled={!isEdit}
            suggestions={suggestionData?.support_phone}
            onBlur={handleBlur}
            error={touched.support_phone && errors.support_phone}
          />
        </div>
      </div>
    </>
  );
};

export default SevenStepOfFollowUps;
